import { StoryblokBlock, BlockTransformContext, hasLink, transformLink } from '~/lib/storyblok'
import type { CtaBlock } from './types'
import { isRichText } from '~/storyblok/isRichText'

export async function transformCtaBlock(
  block: StoryblokBlock,
  { props, options }: BlockTransformContext,
): Promise<CtaBlock> {
  return {
    ...props,
    title: block.title,
    richtext: isRichText(block.richtext) ? block.richtext : null,
    cta: hasLink(block.cta_link)
      ? {
          link: transformLink(block.cta_link),
          label: block.cta_label || null,
        }
      : null,
    options: {
      ...options,
      order: block.option_order || 'text_image',
    },
  }
}
